export const EventCodeMap = {
  // 公共
  '打开页面': 'open_page',
  '实时查询': 'search_realtime',
  '离线下载': 'download_offline',
  '搜索': 'search',
  '点击': 'click',
  '附件下载': 'download_attachment',
  '增加自定义列指标': 'custom_column_add',
  '减少自定义列指标': 'custom_column_reduce',
  '收藏': 'collect',
  '批量收藏': 'collect_batch',

  // 知识库
  '曝光数量V2': 'page_expose',
  '有视频': 'page_with_video',
  '停留时长': 'page_stay_time',
  '视频播放时长': 'video_play_time',

  // 首页
  '拖动卡片': 'layout_drag_card',

  // 客户
  '账户列表页查询': 'page_advertiser_search',
  '新增账户': 'add_account_button',
  '新增帐号': 'add_account_button',
  '“运营人员”列小画笔': 'edit_operator_button',
  '“设计师”列小画笔': 'edit_designer_button',
  '“自理投放管理员”列小画笔': 'edit_self_operator',
  '创意中心': 'jump_tacc',
  '分配设计师': 'assignment_desinger',
  '账户档案': 'account_file',
  '绑定记录': 'bind_record',
  '投放广告': 'jump_advertiser',

  // 报表
  '日期范围': 'date_range',
  '自定义列': 'custom_column_add',

  // 财务
  '转出资金': 'trans_out',
  '充值': 'recharge',
  '转入资金': 'trans_in',
  '批量自理': 'batch_self_care',
  '批量自动转账': 'batch_auto_transfer',
  '批量转入': 'batch_trans_in',
  '查看资金详情': 'fund_details',
  '编辑自定义列': 'custom_column_edit',
  '切换自定义列': 'custom_column_switch',
  '保存自定义列': 'custom_column_save',
  '下载数据-日结报表': 'download_day',
  '修改资金类型': 'fund_type_change',
  '发票开具': 'invoice',

  // 管理
  '新增标签': 'add_label',
  '认领新账户': 'get_new_account',
  'UID切换按钮': 'uid_switch',
  '子帐号UID切换按钮': 'uid_switch_child',
  '新增运营人员KPI': 'add_operator_kpi',
  '新增服务商KPI': 'add_agency_kpi',
  '修改手机号': 'edit_mobile',

  // 任务
  '点击任务卡片“待处理数字”': 'task_card_click_deal_wait_number',
  '点击任务卡片“查看更多”': 'task_card_click_goto_more',
  '点击任务卡片“柱状图”': 'task_card_click_chart_column',
  '点击任务详情“去执行”': 'task_detail_click_goto_implement',
  '点击任务详情“去处理”': 'task_detail_click_goto_deal',
  '点击任务中心“去处理”': 'task_click_goto_deal',
  '点击“忽略”': 'task_click_ignore',
  '点击“标题”': 'task_click_title',
  '点击“标记完成”': 'task_mark_down',
  '点击“收藏任务”': 'task_mark_collect',
  '去处理': 'task_goto_deal',
  '点击团队': 'task_click_team',
  '取消提醒': 'task_cancel_notify',
  '点击知识按钮': 'knowlage_click',

  // 策略相关
  '点击按钮': 'deal_click',
  '看到标记线索': 'lead_view',
  '操作线索': 'lead_operate',
  '看到标记商机': 'potential_view',
  '操作商机': 'potential_operate',

  // 预警监控相关
  '点击监控设置': 'monitor_manage',
  '点击创建规则': 'create_monitor_rule',
  '点击编辑规则': 'edit_monitor_rule',
  '点击删除规则': 'delete_monitor_rule',
  '查看监控提醒': 'check_monitor_notice',
  '调整预算': 'edit_day_budget',
  '点击忽略提醒': 'ignore_monitor_notice',
  '点击跳转广告': 'jump_to_ad',

  // 诊断
  '诊断详情-新建策略': 'diagnose_detail_create_strategy',
  '诊断详情-点击广告': 'diagnose_detail_click_ad',
  '诊断详情-点击筛选框': 'diagnose_detail_click_search',
  '诊断-点击问题标签': 'diagnose_account_problem_tag',
  '诊断-点击账户诊断按钮': 'diagnose_account_but_click',
};

export const UNKNOWN_EVENT_CODE = 'unknown';
